import CarEditForm from "../../Components/Cars/CarEditForm";

function CarEdit() {
  return (
    <div>
      <CarEditForm />
    </div>
  );
}

export default CarEdit;
